import { put } from './requests'

const resourcePath = 'account_role_preferences'

export function updateAccountRolePreference (accountRolePreference) {
  return put(resourcePath, { accountRolePreference })
}
